var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { connect } from "react-redux";
import { GameItem } from "./styles";
import GameThumbnail from "./GameThumbnail";
import favoriteIcon from "../../../assets/img/games/xpress-favorite-game.svg";
import nonFavoriteIcon from "../../../assets/img/games/xpress-non-favorite-game.svg";
import { getLanguageType } from "../../../constants/Language";
import { openGame, pinGame, unPinGame } from "../../../actions/games/creators";
import { openAuthModal } from "../../../actions/auth/creators/Login";
var GameCard = /** @class */ (function (_super) {
    __extends(GameCard, _super);
    function GameCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.openGame = function (gameId) {
            var _a = _this.props, gamblerId = _a.user.gamblerId, langId = _a.langId;
            var lang = getLanguageType(langId).name;
            _this.props.openGameAction({
                gameId: gameId,
                gamblerId: gamblerId,
                lang: lang,
                curr: "KGS",
                returnUrl: window.location.href,
            });
        };
        _this.pinAndUnpin = function (isPinned, gameId) {
            var gamblerId = _this.props.user.gamblerId;
            if (!gamblerId) {
                _this.props.openAuthModal();
                return;
            }
            if (isPinned) {
                _this.props.unPinGameAction(gamblerId, gameId);
            }
            else {
                _this.props.pinGameAction(gamblerId, gameId);
            }
        };
        return _this;
    }
    GameCard.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.errorOpenGame !== this.props.errorOpenGame && this.props.errorOpenGame === -4) {
            this.props.openAuthModal();
            return;
        }
    };
    GameCard.prototype.render = function () {
        var _this = this;
        var game = this.props.game;
        return (_jsxs(GameItem, __assign({ onClick: function () { return _this.openGame(game.Id); } }, { children: [_jsx("img", { className: "game-favorites-icon", src: game.IsPinned ? favoriteIcon : nonFavoriteIcon, alt: "favorite", onClick: function (e) {
                        e.stopPropagation();
                        _this.pinAndUnpin(game.IsPinned, game.Id);
                    }, style: { zIndex: 2 } }), _jsx(GameThumbnail, { game: game }), _jsx("p", __assign({ style: { height: "2em", lineHeight: "1em" } }, { children: game.Name }))] }), game.Id));
    };
    return GameCard;
}(React.Component));
var mapStateToProps = function (state) {
    var _a = state.games.openGame, isLoading = _a.isLoading, error = _a.error;
    var errorOpenGame = state.games.openGame.error;
    return {
        error: error,
        user: state.auth.user,
        langId: state.application.get("languageId"),
        darkTheme: state.application.get("darkTheme"),
        isLoading: isLoading,
        errorOpenGame: errorOpenGame,
    };
};
export default connect(mapStateToProps, {
    pinGameAction: pinGame,
    unPinGameAction: unPinGame,
    openGameAction: openGame,
    openAuthModal: openAuthModal,
})(GameCard);



// WEBPACK FOOTER //
// ./src/components/games/components/GameCard.jsx